module.exports = __webpack_public_path__ + "static/media/proposal.d46b2a36.svg";